export enum AnalyticsCategories {
    Search = 'Search',
    AdvancedSearch = 'Advanced Search',
    Transcripts = 'Transcripts'
}

export enum EventName {
    ContextChangedEvent = 'ContextChangedEvent',
    FacetToggledEvent = 'FacetToggledEvent',
    SortClickedEvent = 'SortClickedEvent',
    PageClickedEvent = 'PageClickedEvent'
}


export function googleAnalytics(event: EventName, category: AnalyticsCategories, label: string | number, value: string | number) {
    window['dataLayer']= window['dataLayer'] || [];

    const tag = {
        event: event,
        Category: category,
        Label: label,
        Value: value
    };
    console.log("Sending tag to data layer: " + JSON.stringify(tag));
    window['dataLayer'].push(tag);
}

export function TriggerAnalyticsEventFor(event: EventName, category: AnalyticsCategories, label: string | number, value: string  |number) {
    googleAnalytics(event, category, label, value);
}
